import * as Yup from "yup";
import {
  createPasswordFieldValidation,
  getActivePasswordPolicy,
  PasswordPolicy
} from "@vilocnv/allsetra-core";
import i18n from "app/integrations/i18n";
import { IResetPassword, INewPassword } from "app/data/types";

export const resetPasswordInitialValues: IResetPassword = { email: "" };

export const resetPasswordValidationSchema: Yup.Schema<IResetPassword> =
  Yup.object().shape({
    email: Yup.string().email().required().label("Email")
  });

export const newPasswordInitialValues: INewPassword = {
  newPassword: "",
  confirmPassword: ""
};

const passwordTranslator = (key: string, options?: Record<string, unknown>) =>
  i18n.t(key, { ns: "formFieldsTranslation", ...options });

export const buildNewPasswordValidationSchema = (
  policy: PasswordPolicy = getActivePasswordPolicy()
): Yup.Schema<INewPassword> =>
  Yup.object().shape({
    newPassword: createPasswordFieldValidation(
      passwordTranslator,
      policy
    ).label("New Password"),
    confirmPassword: Yup.string()
      .test("passwords-match", "Passwords must match", function (value) {
        return this.parent.newPassword === value;
      })
      .label("Confirm Password")
      .required()
  });

export const getNewPasswordFormConfig = () => {
  const policy = getActivePasswordPolicy();

  return {
    policy,
    validationSchema: buildNewPasswordValidationSchema(policy)
  };
};

export const newPasswordValidationSchema: Yup.Lazy<INewPassword> = Yup.lazy(
  () => buildNewPasswordValidationSchema()
);
